import { render, staticRenderFns } from "./StockTab.vue?vue&type=template&id=89f10ea6&scoped=true"
import script from "./StockTab.vue?vue&type=script&setup=true&lang=js"
export * from "./StockTab.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f10ea6",
  null
  
)

export default component.exports